import Modal from "../modal/modal.js";

export default class OrganisationDiagram {
	constructor(config) {
		this.el =
			config.el || document.querySelectorAll(".organisationDiagram");
		this.triggers = this.el.querySelectorAll(".diagramNode__trigger");
		this.diagramNodes = this.el.querySelectorAll(".diagramNode");
		this.visibleClass = "diagramNode--children-visible";
		this.groups = this.el.querySelectorAll(".gridGroupedNode");
		this.init();
	}

	init() {
		const self = this;
		this.attachEvents();
		this.evaluateUrl();
		if (utilities.getSize() != "xsmall") {
			this.updateBoxHeights();
		}
	}

	attachEvents() {
		const self = this;
		var items = document.querySelectorAll(".diagramNode");
		if (items && items.length > -1) {
			items.forEach(item => {
				item.addEventListener("click", event => {
					if (window.innerWidth > 768) {
						// are we above ipad portrait ?
						if (
							item.classList.contains("diagramNode--withContent")
						) {
							self.openModal(item);
						}
					} else {
						//if on mobile up to ipad portait
						if (
							item.classList.contains("diagramNode__trigger") &&
							!item.classList.contains("diagramNode--highlight")
						) {
							//toggle if its not a higlight item and if theres a trigger on it
							this.toggleItem(item);
						} else if (
							// else if the element has content
							item.classList.contains("diagramNode--withContent")
						) {
							// then open it
							self.openModal(item);
						}
					}
				});
			});

			document.addEventListener("AzrModalClose", function() {
				history.pushState("", document.title, window.location.pathname); // reset hash
			});
			utilities.emitter.on("responsive/resize", function(size) {
				if (size !== "xsmall") {
					if (self.groups) {
						self.updateBoxHeights();
					}
				} else {
					self.resetBoxHeights();
				}
			});
		}
	}

	resetBoxHeights() {
		this.diagramNodes.forEach(element => {
			element.style.height = "auto";
		});
	}
	updateBoxHeights() {
		this.groups.forEach(element => {
			let groupElements = element.querySelectorAll(".diagramNode");
			let gorupElementsNodeList = [].slice.call(groupElements);
			const tallest = Math.max.apply(
				Math,
				gorupElementsNodeList.map(function(elem, index) {
					elem.style.height = "";
					return elem.offsetHeight;
				})
			);
			groupElements.forEach(element => {
				element.style.height = tallest + "px";
			});
		});
	}
	toggleItem(element) {
		if (element.classList.contains(this.visibleClass)) {
			this.hideItem(element);
		} else {
			this.showItem(element);
		}
	}
	showItem(element) {
		element.classList.add(this.visibleClass);
		var nodeTitle = element.getAttribute("data-title");
		// update url hash
		var newHash = "#" + nodeTitle;
	}
	hideItem(element) {
		element.classList.remove(this.visibleClass);
		// history.pushState("", document.title, window.location.pathname); // reset hash
	}
	openModal(item) {
		var nodeTitle = item.getAttribute("data-title");
		var elementId = "organisationModal_" + nodeTitle;

		// update url hash
		var newHash = "#" + nodeTitle;

		history.pushState(
			"",
			document.title,
			window.location.pathname + newHash
		);
		// open modal
		new Modal(elementId, item).show();
	}

	evaluateUrl() {
		var hashValue = decodeURI(document.location.hash);
		if (hashValue) {
			var modalId = "organisationModal_" + hashValue.replace("#", "");
			const modalElement = document.querySelector(
				"[data-id='" + modalId + "']"
			);
			if (modalElement) {
				new Modal(modalId).show();
			}
		}
	}
}
